import { render, staticRenderFns } from "./MoiMir.vue?vue&type=template&id=8251985a&scoped=true"
import script from "./MoiMir.vue?vue&type=script&lang=js"
export * from "./MoiMir.vue?vue&type=script&lang=js"
import style0 from "./MoiMir.vue?vue&type=style&index=0&id=8251985a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8251985a",
  null
  
)

export default component.exports